import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function bootstrapSchemaForm() {
  platformBrowserDynamic().bootstrapModule( AppModule )
    .catch( err => console.log( err ) );
}

window[ 'bootstrapSchemaForm' ] = bootstrapSchemaForm;



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/main.ts